import React from 'react';
import { Container, Row, Col, Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import './Footer.css';
import Logo from '../../assets/Logo.png';

const Footer = () => {
  return (
    <footer className="footer-container">
      <div className="footer-glow" aria-hidden />

      {/* ── Main columns ── */}
      <Container className="footer-main">
        <Row>
          {/* Brand */}
          <Col xs={12} lg={3} className="footer-brand">
            <img src={Logo} className="footer-brand-logo" alt="TensorPilot" />
            <p>© {new Date().getFullYear()} TensorPilot AI Inc.</p>
            <p className="footer-email">support@tensorpilot.io</p>
            <address className="footer-address">
              Toronto, ON
            </address>
            <p className="footer-vector-note">
              <a
                href="https://vectorinstitute.ai/ai-adoption/startups/fastlane/"
                target="_blank"
                rel="noopener noreferrer"
              >
                Vector Institute FastLane
              </a>
            </p>

            <div className="footer-social">
              <a href="https://x.com/Tensor_Pilot" target="_blank" rel="noopener noreferrer" aria-label="X / Twitter">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" className="svg-icon">
                  <path d="M389.2 48h70.6L305.6 224.2 487 464H345L233.7 318.6 106.5 464H35.8L200.7 275.5 26.8 48H172.4L272.9 180.9 389.2 48zM364.4 421.8h39.1L151.1 88h-42L364.4 421.8z"/>
                </svg>
              </a>
              <a href="https://www.linkedin.com/company/tensor-pilot" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" className="svg-icon">
                  <path d="M100.28 448H7.4V149.1h92.88zm-46.44-334.6c-29.6 0-53.6-24.1-53.6-53.6S24.28 6.3 53.84 6.3c29.63 0 53.6 24.13 53.6 53.6S83.44 113.4 53.84 113.4zM447.8 448H354.94V302.4c0-34.7-12.9-58.4-45.2-58.4-24.7 0-39.4 16.6-45.9 32.6-2.4 5.8-3 13.8-3 21.9V448h-92.9s1.2-238.4 0-263h92.9v37.3c12.3-19 34.3-46 83.4-46 60.9 0 106.5 39.7 106.5 125.1V448z"/>
                </svg>
              </a>
              <a href="https://www.youtube.com/@tensor-pilot" target="_blank" rel="noopener noreferrer" aria-label="YouTube">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512" className="svg-icon">
                  <path d="M549.655 124.083C534.23 81.062 496.369 49.406 453.946 42.65 410.983 35.76 307.54 32 288 32s-122.983 3.76-165.946 10.65C79.631 49.406 41.769 81.062 26.345 124.083 16.208 154.666 16 228.229 16 228.229s-.208 73.563 10.345 104.146C41.769 430.938 79.631 462.594 122.054 469.35 165.017 476.24 268.46 480 288 480s122.983-3.76 165.946-10.65c42.977-6.889 80.839-38.546 96.263-81.567C559.792 301.792 560 228.229 560 228.229s.208-73.563-10.345-104.146zM232 338.671V138.184L377.276 238.435 232 338.671z"/>
                </svg>
              </a>
              <a href="https://www.reddit.com/r/TensorPilotAI/" target="_blank" rel="noopener noreferrer" aria-label="Reddit">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" className="svg-icon">
                  <path d="M440.3 203.5c-15 0-28.2 6.2-37.9 15.9-35.7-24.7-83.8-40.6-137.1-42.3L293 52.3l88.2 19.8c0 21.6 17.6 39.2 39.2 39.2 22 0 39.7-18.1 39.7-39.7s-17.6-39.7-39.7-39.7c-15.4 0-28.7 9.3-35.3 22l-97.4-21.6c-4.9-1.3-9.7 2.2-11 7.1L246.3 177c-52.9 2.2-100.5 18.1-136.3 42.8-9.7-10.1-23.4-16.3-38.4-16.3-55.6 0-73.8 74.6-22.9 100.1-1.8 7.9-2.6 16.3-2.6 24.7 0 83.8 94.4 151.7 210.3 151.7 116.4 0 210.8-67.9 210.8-151.7 0-8.4-.9-17.2-3.1-25.1 49.9-25.6 31.5-99.7-23.8-99.7zM129.4 308.9c0-22 17.6-39.7 39.7-39.7 21.6 0 39.2 17.6 39.2 39.7 0 21.6-17.6 39.2-39.2 39.2-22 .1-39.7-17.6-39.7-39.2zm214.3 93.5c-36.4 36.4-139.1 36.4-175.5 0-4-3.5-4-9.7 0-13.7 3.5-3.5 9.7-3.5 13.2 0 27.8 28.5 120 29 149 0 3.5-3.5 9.7-3.5 13.2 0 4.1 4 4.1 10.2.1 13.7zm-1-54.3c-21.6 0-39.2-17.6-39.2-39.2 0-22 17.6-39.7 39.2-39.7 22 0 39.7 17.6 39.7 39.7-.1 21.5-17.7 39.2-39.7 39.2z"/>
                </svg>
              </a>
            </div>
          </Col>

          {/* Product */}
          <Col xs={6} sm={4} lg={2} className="footer-nav-col">
            <h6>Product</h6>
            <ul className="list-unstyled">
              <li><Link to="/">TensorPilot AI</Link></li>
              <li><Link to="/download">Download</Link></li>
              <li><Link to="/sales">Pricing</Link></li>
              <li><Link to="/ai-models">AI Models</Link></li>
              <li><Link to="/why-tensorpilot">Why TensorPilot</Link></li>
            </ul>
          </Col>

          {/* Resources */}
          <Col xs={6} sm={4} lg={2} className="footer-nav-col">
            <h6>Resources</h6>
            <ul className="list-unstyled">
              <li><Link to="/blog">Blog</Link></li>
              <li><Link to="/faq">FAQ</Link></li>
              <li><Link to="/about">About Us</Link></li>
              <li><Link to="/contactus">Support</Link></li>
              <li><Link to="/careers">Careers</Link></li>
            </ul>
          </Col>

          {/* Legal */}
          <Col xs={6} sm={4} lg={2} className="footer-nav-col">
            <h6>Legal</h6>
            <ul className="list-unstyled">
              <li><a href="/terms-and-conditions" target="_blank" rel="noopener noreferrer">Terms &amp; Conditions</a></li>
              <li><a href="/privacy-policy" target="_blank" rel="noopener noreferrer">Privacy Policy</a></li>
            </ul>
          </Col>

          {/* Account */}
          <Col xs={12} sm={12} lg={3} className="footer-nav-col footer-account-col">
            <h6>Account</h6>
            <ul className="list-unstyled">
              <li><Link to="/login">Sign in</Link></li>
              <li><Link to="/signup">Create account</Link></li>
            </ul>
            <div className="footer-cta-buttons mt-3">
              <Button as={Link} to="/login" className="footer-btn-login" size="sm">
                Sign in
              </Button>
              <Button as={Link} to="/signup" className="footer-btn-signup" size="sm">
                Sign up
              </Button>
            </div>
          </Col>
        </Row>
      </Container>

      {/* ── Bottom bar ── */}
      <Container>
        <div className="footer-bottom-bar">
          <div className="footer-bottom-inner">
            <p className="footer-copyright">
              © {new Date().getFullYear()} TensorPilot AI Inc. All rights reserved.
            </p>
            <div className="footer-bottom-links">
              <a href="/terms-and-conditions" target="_blank" rel="noopener noreferrer">Terms</a>
              <a href="/privacy-policy" target="_blank" rel="noopener noreferrer">Privacy</a>
              <Link to="/contactus">Contact</Link>
            </div>
          </div>
        </div>
      </Container>

      {/* SEO nav — hidden from users, visible to crawlers */}
      <nav
        style={{ position: 'absolute', left: '-9999px', width: '1px', height: '1px', overflow: 'hidden' }}
        aria-label="SEO Navigation"
      >
        <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
          <li><a href="https://www.tensorpilot.io/">Home</a></li>
          <li><a href="https://www.tensorpilot.io/download">Download</a></li>
          <li><a href="https://www.tensorpilot.io/sales">Pricing</a></li>
          <li><a href="https://www.tensorpilot.io/blog">Blog</a></li>
          <li><a href="https://www.tensorpilot.io/faq">FAQ</a></li>
          <li><a href="https://www.tensorpilot.io/contactus">Contact Us</a></li>
          <li><a href="https://www.tensorpilot.io/careers">Careers</a></li>
          <li><a href="https://www.tensorpilot.io/about">About Us</a></li>
          <li><a href="https://www.tensorpilot.io/login">Login</a></li>
          <li><a href="https://www.tensorpilot.io/signup">Sign Up</a></li>
        </ul>
      </nav>
    </footer>
  );
};

export default Footer;
